import React, { FC, ReactElement } from "react";
//import React from "react";
//import { Box, Divider, Grid, Typography, Link } from "@mui/material";

function Header() {

  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const loggedIn = sessionStorage.getItem("loggedIn");
  const tipocuenta = userData?.tipocuenta;
  
  //const username = userData?.username;
  //const clienteid = userData?.clienteid;

  if(!loggedIn){
   return;      
  }

//if (!loggedIn) {
//  imglogin = <a href="/Login"><img src="/images/Sesion_P.png" alt="Iniciar Sesion"></img></a>;
//} else {
//  imglogin = <a href="/Logout"><img src="/images/Sesion_P.png" alt="Finalizar Sesion"></img></a>;
//}
  return (
     

    <div class="footer-container">
      
    <div class="div-left">
      <ul class="footer">
        <li>
        {tipocuenta ==='AdminItalika' ? (
        <a class="img1" id="header_logo" href="/DashboardAdminItalika" title="Boxer Logistica"><img src="/images/Logoboxerlogistica.png" alt="Boxer Logistica Home Page"></img></a>
      ) : tipocuenta ==='UserItalika' ? (
        <a class="img1" id="header_logo" href="/DashboardItalika" title="Boxer Logistica"><img src="/images/Logoboxerlogistica.png" alt="Boxer Logistica Home Page"></img></a>
      ) : tipocuenta ==='Admin' ? (
        <a class="img1" id="header_logo" href="/DashboardAdmin" title="Boxer Logistica"><img src="/images/Logoboxerlogistica.png" alt="Boxer Logistica Home Page"></img></a>
      ) : (
        <a class="img1" id="header_logo" href="/Dashboard" title="Boxer Logistica"><img src="/images/Logoboxerlogistica.png" alt="Boxer Logistica Home Page"></img></a>
      )}
        
        </li>
      </ul>
    </div>
    <div class="div-right">
      <ul class="footer">
        <li>
        {!loggedIn ? (
        <a href="/Login"><img src="/images/Sesion_P3.png" alt="Iniciar Sesion"></img></a>
      ) : (
        <a href="/Logout"><img src="/images/Sesion_P2.png" alt="Finalizar Sesion"></img></a>
      )}
        </li>
       </ul>
     </div>
   </div>
  );
};

export default Header;